import * as leaseDepositReturnTypes from 'constants/enums/leaseDepositReturnTypes'

export default {
  [leaseDepositReturnTypes.DAYS_AFTER_HANDOVER]: 'do X dnů od předání bytu',
  [leaseDepositReturnTypes.AFTER_ADVANCE_SETTLEMENT]: 'po vyúčtování záloh',
  [leaseDepositReturnTypes.OTHER]: 'jiná varianta',
}
